<template>
  <div tabindex="18" class="grid-container full">
    <div class="grid-x programemsCarousel page-contents-8">
      <div class=" small-12 cell">
        <div class="grid-x">
          <div class="small-12 cell">
            <h2>Vantage helps<br class="show-for-small-only"/> candidates secure<br class="show-for-small-only"/> opportunities.</h2>
          </div>
        </div>


        <div class="grid-x">
          <div class="medium-2 cell align-center align-middle hide-for-small-only" style="display: flex; " @click="previous">
            <img tabindex="18" class="prevArrow" src="@/assets/img/icons/left-carousel-arrow.png" @keypress="previous" />
          </div>
          <div class="small-12 medium-8 cell">

            <div class='carousel-view'>
              <transition-group
                name='carousel'
                class='carousel'
                tag="div">
                <div
                  v-for="slide in slides"
                  class='slide'
                  :key="slide.id">
                  <div class="carouselContent">
                    <img class="quote-mark" src="@/assets/img/icons/quote.png" />
                    <p class="quote">{{ slide.quote }}</p>
                    <p class="candidate">{{ slide.candidate }},<br/>{{slide.company}}</p>
                  </div>
                </div>
              </transition-group>
            </div>

          </div>
          <div class="medium-2 cell align-center align-middle hide-for-small-only" style="display: flex; " @click="next">
            <img tabindex="18" class="nextArrow" src="@/assets/img/icons/right-carousel-arrow.png" @keypress="next" />
          </div>
        </div>

        <div class="grid-x mobile-buttons show-for-small-only">
          <div class="small-12 cell text-center">
            <div class="mobile-buttons-row">
              <div
                v-for="(slide, index) in slides"
                class='mobile-button'
                :class="{ mobileButtonActive: isCurrentButton(index + 1) }"
                :key="slide.id"
                @click="moveCarousel(index + 1)">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RareQuotesCarousel',
  components: {
  },
  data() {
    return {
      w: window.width,
      largeText: null,
      smallText: null,
      currentSlide: 1,
      slides: [
        {
          quote: 'Vantage has been an incredible platform that has helped me throughout the vacation scheme application process.',
          candidate: 'Beste, 2nd year law student',
          company: 'University of Southampton',
          id: 4,
        },
        {
          quote: 'Vantage has been a brilliant tool throughout the application process by allowing me to interact with a variety of Vantage\'s partner law firms.',
          candidate: 'Cara, Future Trainee Solicitor',
          company: 'Freshfields',
          id: 5,
        },
        {
          quote: 'Vantage has been instrumental in my success securing my dream training contract with a magic circle firm.',
          candidate: 'Marshall, Final year law student',
          company: 'University of Warwick',
          id: 1,
        },
        {
          quote: 'Vantage was the catalyst for securing my training contract with Lewis Silkin.',
          candidate: 'Jemma, Future Trainee Solicitor',
          company: 'Lewis Silkin',
          id: 2,
        },
        {
          quote: 'Vantage has been extremely helpful throughout my application process.',
          candidate: 'Tobi, Future Trainee Solicitor',
          company: 'Clifford Chance',
          id: 3,
        },
      ],
    };
  },


  methods: {
    next() {
      const first = this.slides.shift();
      const length = this.slides.length + 1;
      console.log(length);

      this.slides = this.slides.concat(first);
      this.currentSlide += 1;
      if (this.currentSlide > length) { this.currentSlide = 1; }
    },
    previous() {
      const last = this.slides.pop();
      const length = this.slides.length;

      this.slides = [last].concat(this.slides);
      this.currentSlide -= 1;
      if (this.currentSlide < 1) { this.currentSlide = length + 1; }
    },
    moveCarousel(id) {
      const currentSlide = this.currentSlide;
      const stepsToMove = id - currentSlide;

      if (id < currentSlide) {
        for (let i = 0; i > stepsToMove; i -= 1) {
          this.previous();
        }
      } else if (id > currentSlide) {
        for (let i = 0; i < stepsToMove; i += 1) {
          this.next();
        }
      }
    },
    isCurrentButton(id) {
      return this.currentSlide === id;
    },
    whySignUp() {
      window.location.assign('/why-sign-up');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .carouselContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: space-between;
    height: 230px;
  }

  .quote-mark {
    height: 45px;
    margin: 0 auto 25px auto;
  }

  h2
  {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  a {
    color: #ffffff;
    text-decoration: none;
  }

  .mobile-buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 22px;
    margin-top: -22px;
  }

  .mobile-buttons-row {

  }

  .mobile-button {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #ffffff;
    cursor: pointer;
  }

  .mobile-button:last-of-type {
    margin-right: 0;
  }

  .mobileButtonActive {
    background-color: $green-highlight;
  }

  @media only screen and (max-width: 640px)  {
    .programemsCarousel {
      min-height: 450px;
      background-position: center;
      background-color: $dark-grey-background;
    }

    h2 {
      font-size: 24px;
      line-height: 1.43;
      margin: 30px 0 30px 0;
    }

    .carouselLabel {
    }

    .slide {
      flex: 0 0 20em;
    }

    .carousel {
      padding-left: 260px;
    }

    .quote {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.3;
      text-align: center;
    }

    .candidate {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      text-align: center;
      color: $green-highlight;
    }

    .signup {
      margin-bottom: 40px;
    }
  }

  @media only screen and (min-width: 641px)  {
    .programemsCarousel {
      min-height: 393px;
      background-color: $dark-grey-background;
    }

    h2 {
      font-size: 40px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      text-align: center;
      margin: 40px 0 40px 0;
    }

    .quote {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.3;
      text-align: center;
    }

    .candidate {
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      text-align: center;
      color: $green-highlight;
    }

    .carouselContent {
      padding: 0 30px 0 30px;
    }

    .carousel {
      padding-left: 0;
    }

    .slide {
      flex: 0 0 40em;
    }

  }

  .carousel-view {
    //border: 2px solid blue;
    height: 230px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 30px;
  }

  .carousel {
    //border: 2px solid green;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 230px;
    overflow: hidden;
  }

  .slide {
    //border: 2px solid red;
    transform: translateZ(0) scale(1.0, 1.0);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: transform 0s ease-in-out;
    opacity: 0.5;
    overflow: hidden;
  }

  @media only screen and (max-width: 801px) {
    .carousel {
      padding-right: 250px;
    }
  }

  .slide:nth-of-type(3) {
    opacity: 1 !important;
  }

  .carousel-controls {
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 99;
    position: relative;
    display: block;
  }

  .prevArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  .nextArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .carousel {
      text-align: center;
    }
    .slide {
      display: none;
      overflow: visible;
      width: 100%;
      transition: none;
    }

    .slide:nth-of-type(3) {
      display: block !important;
      opacity: 1 !important;
      text-align: center;
      margin: 50px 0 0 25%;
    }

    .slide:nth-of-type(3) span {
      opacity: 1 !important;
      border-bottom: 5px solid $green-highlight;
      text-align: center;
      margin-right: 170px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/quotesCarousel.vue